import React from 'react';

import { useTheme } from '@mui/material/styles';

function DownArrowIcon({ isActive }) {
    const theme = useTheme();

    const color = isActive ? theme.palette.primary.main : theme.palette.icons.color;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" className="valign-middle">
            <path stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="m8 14 4 4m0 0 4-4m-4 4V6" />
        </svg>
    );
}

export default DownArrowIcon;
